import { imagsServerUrl } from "../../../configurations/configuration.json";
import ClButtonsApiHandler from '../../public/js/api/ClButtonsApiHandler';
import ClSelect from './components/Select/ClSelect';
import { getURL } from './utils/utils';
// 
const CLS_IMGS_SERVER_URL = `${imagsServerUrl}/buttons/v2`;
const CLS_BTNS_IMGS_URL = `${CLS_IMGS_SERVER_URL}/static/buttons/v2/price`;
// let elesViewer;
export const registerSelectPositionFunct = async () => {
    console.log('Starting select buttin positioning funcionality');
    const pluginTheme = 'themeV2';
    // 
    const fldSlctPos = document.querySelector('#clk_op_position');
    const selectPagePosFld = ClSelect(fldSlctPos.id, 'modal',
        [...fldSlctPos.options].map(opEle => ({ value: `${CLS_IMGS_SERVER_URL}/btn-position/product/${opEle.value}.svg`, label: opEle.label })),
        {
            tlt: 'Select button position in product page',
            desc: 'Click the option where you want to show the button and then save the changes',
            cardSize: 'fixed-2',
            defValue: `${getURL()}/btn-position/${fldSlctPos.value}.svg`,
            cardOpts: {
            }
        });
    const slctBtnPosProdEle = await selectPagePosFld.build();
    slctBtnPosProdEle?.classList.add(pluginTheme);
    document.querySelector(`.cl-modal[id*=${slctBtnPosProdEle.id}]`)?.classList.add('themeV2');
}


export const AdminSettings = function () {

    const state = {
        formEss: {
            isInCart: document.querySelector('#clk_op_is_in_cart'),
            cartPos: document.querySelector('#clk_cart_pos')
        }
    };

    const registerBtnPosCartFunct = async () => {
        const fldCartPos = document.querySelector('#clk_cart_pos');
        let selectCartPosEle = ClSelect(fldCartPos.id, 'modal',
            // [...fldCartPos.options].map(opEle => ({ value: `btn-position/cart/${opEle.value}`, label: opEle.label })),
            [...fldCartPos.options].map(opEle => ({ value: `${CLS_IMGS_SERVER_URL}/btn-position/cart/${opEle.value}.svg`, label: opEle.label })),
            {
                tlt: 'Select button position in shopping cart page',
                desc: 'Click on the option where you want to show the button and then save the changes',
                cardSize: 'fixed-2', // when fixed the second number is numer of columns
                defValue: `${getURL()}/btn-position/cart/${fldCartPos.value}.svg`

            });
        selectCartPosEle = await selectCartPosEle.build();
        document.querySelector(`.cl-modal[id*=${fldCartPos.id}]`)?.classList.add('themeV2');
    }

    const registerPickBtnFunct = async () => {
        const pluginTheme = 'themeV2';
        // 
        const btnsOptsHandlr = new ClButtonsApiHandler();
        // const btnsList = await getBtnGroups();
        const btnsList = await btnsOptsHandlr.getAllButtonOptions();
        const scltOptions = btnsList.map(btn => ({ value: btn.url, label: btn.label }));
        const fldBtnDesign = document.querySelector('#clk_op_button_design');
        // console.log(btnsList);
        const selectBtnDesign = ClSelect(fldBtnDesign.id, 'modal',
            // [{ value: 'prim-light-1', label: 'Default, Light Background, Blue Button' }],
            scltOptions,
            {
                tlt: 'Select button color',
                desc: 'The buttons are transparent. The background color is shown for example only.',
                cardSize: 'fixed-1', // when fixed the second number is numer of columns
                defValue: `${CLS_IMGS_SERVER_URL}/price/${fldBtnDesign.value}-price.svg`,
                cardOpts: {
                    cardSize: 'fixed-1', // when fixed the second number is numer of columns
                    icon: {
                        pos: 'down'
                    },
                    align: 'left', // left, right or center,
                    highlight: 'content', // none, full, content, label,

                }
            }
        );
        const slctBtnDesignEle = await selectBtnDesign.build();
        // set styles to a theme
        slctBtnDesignEle.classList.add(pluginTheme);
        document.querySelector(`.cl-modal[id*=${fldBtnDesign.id}]`)?.classList.add(pluginTheme);
        [...fldBtnDesign.options]
            .map(b => b?.value.toLowerCase().includes('dark'))
            .forEach((isDark, i) => {
                const cards = document.querySelectorAll(`.cl-modal[id*=${fldBtnDesign.id}] .cl-btn-card-list .cl-btn-card-item`);
                if (cards.length && isDark) cards[i].classList.add('dark');
            })
    }

    const load = () => {
        registerPickBtnFunct();
        registerBtnPosCartFunct();
    }

    return { load };
}

export const registerNumFldsFunct = () => {
    document.querySelectorAll('input[class*=cl-fld][type=number]').forEach(numFld => {
        numFld.oninput = (e) => {
            let { valueAsNumber, value } = e.target;
            // console.log(e.target);
            //  if not a number set a empty string
            if (valueAsNumber || valueAsNumber === 0) {
                // if lesser than 0 sets an empty string
                if (valueAsNumber < 0) {
                    numFld.value = null;
                    return;
                }
                // avoids typing  trailing numbers
                if (value.length > 1) numFld.value = value.replace(/^0+/, '');
            } else numFld.value = '';
        }
    });
}

/*---------New maind setttings desing---------------*/
/* Token Label*/
export const requiredTokenLbl = () => {
    const myBody = document.getElementsByTagName("body")[0];
    const myBodyTr = myBody.getElementsByTagName("tr");
    const myTr = myBodyTr[0].firstChild;
    myTr.classList.add('tr-clk-class');
}

// /*Submit button*/
export const submitSetButton = () => {
    console.log('Creating submit button');
    const subButton = [...document.querySelectorAll('input[id*=submit][type=submit]')]?.shift();
    const tbodyEle = document.querySelector('form[class*=cl-stt] table tbody');
    if (subButton) {
        const newRowEle = document.createElement('tr');
        subButton.classList.remove('button');
        newRowEle.innerHTML = `<th scope="row"></th><td>
            <div class="cl-app-btn-wrapp--submit">
            ${subButton.outerHTML}
            </div>
        </td>`;
        tbodyEle.appendChild(newRowEle);
        subButton.parentElement.remove();
    };
}


window.addEventListener('load', (e) => {

});